import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const TableIcon = React.memo(function TableIcon(props: TTableIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Table" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.5 11.75v4.75h6.75v-4.75H3.5Zm0-1.5h6.75V5.5H3.5v4.75Zm8.25 1.5v4.75h6.75v-4.75h-6.75Zm6.75-1.5h-6.75V5.5h6.75v4.75ZM3 4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H3Z"
            />
        </IconBase>
    );
});

export default TableIcon;

// #region Types

export type TTableIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <TableIcon /> : { ...IconBaseExample, render: TableIcon };

// #endregion
